module.exports = __webpack_public_path__ + "img/memorabilia_bg.769b8e90.jpg";